import type { Movement } from "./types";
import { addMonthsClamped } from "./installments";
import { mexicoCityIsoDate } from "./periods";

/** El fondeo, el calendario y la confirmación bancaria son estados independientes. */
export function isExpectedInstallment(movement: Movement, _today?: string): boolean {
  return Boolean(movement.installmentPurchaseId && movement.installmentNumber !== 1
    && movement.bankPostingState !== "confirmed"
    && movement.cardPaymentStatus !== "paid" && !movement.historicalSettlement);
}

export function movementActivityDate(movement: Movement): string {
  return String(movement.bankPostingState === "confirmed" && movement.bankPostingConfirmedAt
    ? movement.bankPostingPostedOn ?? mexicoCityIsoDate(new Date(movement.bankPostingConfirmedAt)) : movement.bankPostingState === "scheduled" && movement.bankPostingExpectedOn
      ? movement.bankPostingExpectedOn : movement.spentOn ?? movement.createdAt).slice(0, 10);
}

export function isRecordedActivity(movement: Movement, today: string): boolean {
  return movement.kind === "expense" && !isExpectedInstallment(movement, today)
    && movementActivityDate(movement) <= today;
}

export function bankPostingLabel(movement: Movement, today?: string): string {
  if (movement.cardPaymentStatus === "paid" || movement.historicalSettlement) return "Pagado al banco";
  if (movement.bankPostingState === "scheduled" && movement.bankPostingExpectedOn) return today && movement.bankPostingExpectedOn <= today
    ? "Fecha prevista alcanzada · por confirmar" : `Prevista para ${movement.bankPostingExpectedOn}`;
  if (isExpectedInstallment(movement)) return "Prevista · sin confirmar en el banco";
  if (movement.bankPostingState === "confirmed") return "Confirmada en el banco";
  return "Compra capturada";
}

export function confirmInstallmentPosting(movement: Movement, confirmed: boolean, now: string, scheduledOn?: string, postedOn?: string): Movement {
  if (movement.kind !== "expense" || !movement.installmentPurchaseId || movement.installmentNumber === 1) {
    throw new Error("Esta acción corresponde a una parcialidad posterior de un plan MSI.");
  }
  if (movement.cardPaymentStatus === "paid" || movement.historicalSettlement) {
    throw new Error("El corte pagado conserva su historial.");
  }
  if (scheduledOn && !addMonthsClamped(scheduledOn, 0)) throw new Error("La fecha de cargo indicada no existe.");
  if (postedOn && (!addMonthsClamped(postedOn, 0) || postedOn > mexicoCityIsoDate(new Date(now)))) throw new Error("La fecha confirmada debe existir y no puede ser futura.");
  return { ...movement, bankPostingState: confirmed ? "confirmed" : scheduledOn ? "scheduled" : "expected",
    bankPostingRevision: (movement.bankPostingRevision ?? 0) + 1,
    bankPostingExpectedOn: scheduledOn,
    bankPostingPostedOn: confirmed ? postedOn ?? mexicoCityIsoDate(new Date(now)) : undefined,
    bankPostingConfirmedAt: confirmed ? now : undefined };
}
